<template>
    <div class="table_wrap">
        <el-table :data="commentData"
                  class="list-table"
                  header-cell-class-name="list-header"
                  empty-text="데이터가 없습니다."
                  @cell-click="handlerCellClick"
        >
           <!-- <el-table-column
                    type="selection"
                    class-name="text-center"
                    min-width="25">
            </el-table-column>-->
            <el-table-column class="table_no" type="index" label="No" min-width="45" class-name="num text-center" :index="tableIdx"></el-table-column>
            <el-table-column label="작성자" width="300" prop="Writer" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        <img :src="returnProfile(scope.row.Writer)" alt="" width="50" height="50" class="verti-middle img-profile-border">
                        <span class="verti-middle pl5">{{scope.row.Writer.mb_nick}}</span>
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="내용" prop="wr_content" class-name="text-center">
                <template slot-scope="scope">
                    <span v-html="replaceBr(scope.row.wr_content)"></span>
                </template>
            </el-table-column>
            <el-table-column label="작성일자" width="150" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{returnDateUnix(scope.row.created_at, 'YYYY-MM-DD HH:mm')}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="옵션" width="100" class-name="text-center">
                <template slot-scope="scope">
                    <div class="row-info">
                        <el-button @click="runDelete(scope.row.wr_id)">
                            삭제
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import util from "@/mixins/util";
    import dateMixins from "@/mixins/dateMixins";
    import imageOption from "@/mixins/imageOption";
    import EventBus from "@/utils/event-bus";
    export default {
        name: "CommentPopupListLayout",
        mixins: [dateMixins, imageOption],
        components: {}, 
        inject: ['setPage', 'boardCommentSetData', 'boardCommentDelete'],
        provide() {
            return {}
        },
        props: {
            boardType: '',
            commentData: {
                default: () => {
                    return []
                }
            },
            paginationData: {
                default: () => {
                    return {total: 0, page: 0, size: 0,}
                }
            },
        },
        data() {
            return {}
        },
        created() {
        },
        mounted() {
        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {},
        methods: {
            tableIdx(index) {
                return this.commentData.length - index;
            },
            // tableSelectChange(row) {
            //     this.selectArr = [];
            //     util.Array.each(row, (obj, index, arr) => {
            //         this.selectArr.push(obj.wr_id);
            //     });
            //     this.boardListSetData('selectArr', this.selectArr)
            // },

            returnProfile(writer) {
                return util.isEmpty(writer) || util.isEmpty(writer.Profile) ? '' : `${writer.Profile[0].org_url}?${this.setImageOptions(50, 50, 'png')}`
            },
            replaceBr(content) {
                if (util.isEmpty(content)) {
                    return '';
                }
                return content.replace(/(\n|\r\n)/g, '<br>');
            },
            handlerCellClick(row, column, cell, event) {
                if(column.property === 'Writer') {
                    this.$router.push(`/student/member/${row.mb_no}`)
                }
            },
            runDelete(key) {
                this.boardCommentSetData('selectArr', [key]);
                this.$nextTick(() => {
                    this.boardCommentDelete();
                })
            },
        },
        watch: {},
    }
</script>

<style scoped>

</style>
